export class Owner {
    _id: string;
    name: string;

    constructor(owner?) {
        if (owner)
            this.populate(owner)
    }

    public populate(owner: any) {
        this._id = owner._id;
        this.name = owner.name;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/billing-letter/Owner.model.ts